import { createContext, useContext } from 'react';

type Context = {
  value?: string;
};

export const PickerContext = createContext<Context>({});
export const usePickerContext = () => useContext(PickerContext);
